import { put, takeLatest } from 'redux-saga/effects';
import config from '@/config';
import { HTTP_CODE, STATE_KEY, TOKEN_KEY } from '@/common/constant';
import { getLocalStorageValue, getRedirectUri, parseQueryString } from '@/common/utils';
import Api from '@/common/api';
import {
  REFRESH_TOKEN,
  SET_CURRENT_USER_BUSINESSES_SUCCESS,
  SET_CURRENT_USER_IRS,
  SIGN_OUT_USER,
  VERIFY_TOKEN,
} from '../types/authenticate';
import { requestGetUserIRS, requestTokenApi } from '../requests/authenticate';
import { showMessageFailed } from '@/utils';

const { client_id, client_secret, ssoUrl } = config;

function* currentUserIRS() {
  const irsUser = yield requestGetUserIRS();
  const { businesses_user_can_manage, ...rest } = irsUser || {};
  yield put({
    type: SET_CURRENT_USER_BUSINESSES_SUCCESS,
    payload: { userBusinesses: businesses_user_can_manage, user: rest },
  });
}

/**
 * Handle sign out session
 * @param {*} param0
 */
function* signOutUser({ callback }) {
  try {
    const token = getLocalStorageValue(TOKEN_KEY);
    const state = getLocalStorageValue(STATE_KEY);
    let redirectUri = null;
    try {
      if (token && state) {
        const tokenData = JSON.parse(token);
        const { id_token, access_token } = tokenData;
        const parseURL = getRedirectUri('auth/logout');
        const uriObj = [
          `post_logout_redirect_uri=${parseURL}`,
          `id_token_hint=${id_token}`,
          `client_id=${client_id}`,
          `client_secret=${client_secret}`,
          `access_token=${access_token}`,
          `state=${state}`,
          'response_type=code',
        ];
        redirectUri = `${ssoUrl}/oauth2/sessions/logout?${uriObj.join('&')}`;
      }
      yield callback(redirectUri);
    } catch (err) {
      // console.log(err);
    }
  } catch (err) {
    // console.error('signOutUser : ', err);
  }
}

/**
 * Handle refresh token
 * @param {*} payload
 * @returns
 */
function* refreshToken(payload) {
  const { callback } = payload;
  try {
    const data = yield Api.refreshToken();
    Api.autoRefreshToken();

    if (callback) yield callback(true);
  } catch (error) {
    showMessageFailed({ error });
    if (error?.responseError?.status === HTTP_CODE[400] && callback) {
      yield callback(false);
    }
  }
}

/**
 * Handle request verify token
 * @param {*} payload
 */
function* requestVerifyToken(payload) {
  try {
    const { params, callback } = payload;
    const { search, redirect_uri } = params;
    const { state, code } = parseQueryString(search);
    const currentState = localStorage.getItem(STATE_KEY);
    const queryString = new URLSearchParams({
      client_id,
      client_secret,
      redirect_uri,
      grant_type: 'authorization_code',
      code,
    }).toString();
    let token = null;
    if (state === currentState) {
      token = yield requestTokenApi({ queryString, ssoUrl });
      const { expires_in } = token;
      const currentDate = new Date();
      const expires_date = currentDate.setSeconds(currentDate.getSeconds() + expires_in - 10);
      localStorage.setItem(
        TOKEN_KEY,
        JSON.stringify({
          ...token,
          expires_date,
          redirect_uri,
        }),
      );
    }
    callback(token);
  } catch (err) {
    //
  }
}

export default [
  takeLatest(SET_CURRENT_USER_IRS, currentUserIRS),
  takeLatest(SIGN_OUT_USER, signOutUser),
  takeLatest(REFRESH_TOKEN, refreshToken),
  takeLatest(VERIFY_TOKEN, requestVerifyToken),
];
